const mapType = "Google Maps";
const regionLatinAmerica = "South/Latin America";
const regionAsiaPacific = "Asia & Pacific";
const regionMiddleEast = "Middle East";
const regionArabStates = "Arab States";
const regionNorthAmerica = "North America";

export const COUNTRIES = [
    {
      "id": 14,
      "name": "Aruba",
      "mapType": mapType,
      "isoCode": "ABW",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 3,
      "name": "Afghanistan",
      "mapType": mapType,
      "isoCode": "AFG",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 8,
      "name": "Angola",
      "mapType": mapType,
      "isoCode": "AGO",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 5,
      "name": "Anguilla",
      "mapType": mapType,
      "isoCode": "AIA",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 15,
      "name": "Åland Islands",
      "mapType": mapType,
      "isoCode": "ALA",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 6,
      "name": "Albania",
      "mapType": mapType,
      "isoCode": "ALB",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 1,
      "name": "Andorra",
      "mapType": mapType,
      "isoCode": "AND",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 2,
      "name": "United Arab Emirates",
      "mapType": mapType,
      "isoCode": "ARE",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 10,
      "name": "Argentina",
      "mapType": mapType,
      "isoCode": "ARG",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 7,
      "name": "Armenia",
      "mapType": mapType,
      "isoCode": "ARM",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 11,
      "name": "American Samoa",
      "mapType": mapType,
      "isoCode": "ASM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 9,
      "name": "Antarctica",
      "mapType": mapType,
      "isoCode": "ATA",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 216,
      "name": "French Southern Territories",
      "mapType": mapType,
      "isoCode": "ATF",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 4,
      "name": "Antigua and Barbuda",
      "mapType": mapType,
      "isoCode": "ATG",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 13,
      "name": "Australia",
      "mapType": mapType,
      "isoCode": "AUS",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 12,
      "name": "Austria",
      "mapType": mapType,
      "isoCode": "AUT",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 16,
      "name": "Azerbaijan",
      "mapType": mapType,
      "isoCode": "AZE",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 24,
      "name": "Burundi",
      "mapType": mapType,
      "isoCode": "BDI",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 20,
      "name": "Belgium",
      "mapType": mapType,
      "isoCode": "BEL",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 25,
      "name": "Benin",
      "mapType": mapType,
      "isoCode": "BEN",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 30,
      "name": "Bonaire, Sint Eustatius and Saba",
      "mapType": mapType,
      "isoCode": "BES",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 21,
      "name": "Burkina Faso",
      "mapType": mapType,
      "isoCode": "BFA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 19,
      "name": "Bangladesh",
      "mapType": mapType,
      "isoCode": "BGD",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 22,
      "name": "Bulgaria",
      "mapType": mapType,
      "isoCode": "BGR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 23,
      "name": "Bahrain",
      "mapType": mapType,
      "isoCode": "BHR",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 32,
      "name": "Bahamas",
      "mapType": mapType,
      "isoCode": "BHS",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 17,
      "name": "Bosnia and Herzegovina",
      "mapType": mapType,
      "isoCode": "BIH",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 26,
      "name": "Saint Barthélemy",
      "mapType": mapType,
      "isoCode": "BLM",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 36,
      "name": "Belarus",
      "mapType": mapType,
      "isoCode": "BLR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 37,
      "name": "Belize",
      "mapType": mapType,
      "isoCode": "BLZ",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 27,
      "name": "Bermuda",
      "mapType": mapType,
      "isoCode": "BMU",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 29,
      "name": "Bolivia, Plurinational State of",
      "mapType": mapType,
      "isoCode": "BOL",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 31,
      "name": "Brazil",
      "mapType": mapType,
      "isoCode": "BRA",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 18,
      "name": "Barbados",
      "mapType": mapType,
      "isoCode": "BRB",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 28,
      "name": "Brunei Darussalam",
      "mapType": mapType,
      "isoCode": "BRN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 33,
      "name": "Bhutan",
      "mapType": mapType,
      "isoCode": "BTN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 34,
      "name": "Bouvet Island",
      "mapType": mapType,
      "isoCode": "BVT",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 35,
      "name": "Botswana",
      "mapType": mapType,
      "isoCode": "BWA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 41,
      "name": "Central African Republic",
      "mapType": mapType,
      "isoCode": "CAF",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 38,
      "name": "Canada",
      "mapType": mapType,
      "isoCode": "CAN",
      "active": true,
      "regionId": 7,
      "region": {
        "id": 7,
        "name": regionNorthAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 39,
      "name": "Cocos (Keeling) Islands",
      "mapType": mapType,
      "isoCode": "CCK",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 43,
      "name": "Switzerland",
      "mapType": mapType,
      "isoCode": "CHE",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 46,
      "name": "Chile",
      "mapType": mapType,
      "isoCode": "CHL",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 48,
      "name": "China",
      "mapType": mapType,
      "isoCode": "CHN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 44,
      "name": "Côte d'Ivoire",
      "mapType": mapType,
      "isoCode": "CIV",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 47,
      "name": "Cameroon",
      "mapType": mapType,
      "isoCode": "CMR",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 40,
      "name": "Congo, the Democratic Republic of the",
      "mapType": mapType,
      "isoCode": "COD",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 42,
      "name": "Congo",
      "mapType": mapType,
      "isoCode": "COG",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 45,
      "name": "Cook Islands",
      "mapType": mapType,
      "isoCode": "COK",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 49,
      "name": "Colombia",
      "mapType": mapType,
      "isoCode": "COL",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 119,
      "name": "Comoros",
      "mapType": mapType,
      "isoCode": "COM",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 52,
      "name": "Cape Verde",
      "mapType": mapType,
      "isoCode": "CPV",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 50,
      "name": "Costa Rica",
      "mapType": mapType,
      "isoCode": "CRI",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 51,
      "name": "Cuba",
      "mapType": mapType,
      "isoCode": "CUB",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 53,
      "name": "Curaçao",
      "mapType": mapType,
      "isoCode": "CUW",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 54,
      "name": "Christmas Island",
      "mapType": mapType,
      "isoCode": "CXR",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 124,
      "name": "Cayman Islands",
      "mapType": mapType,
      "isoCode": "CYM",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 55,
      "name": "Cyprus",
      "mapType": mapType,
      "isoCode": "CYP",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 56,
      "name": "Czech Republic",
      "mapType": mapType,
      "isoCode": "CZE",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 57,
      "name": "Germany",
      "mapType": mapType,
      "isoCode": "DEU",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 58,
      "name": "Djibouti",
      "mapType": mapType,
      "isoCode": "DJI",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 60,
      "name": "Dominica",
      "mapType": mapType,
      "isoCode": "DMA",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 59,
      "name": "Denmark",
      "mapType": mapType,
      "isoCode": "DNK",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 61,
      "name": "Dominican Republic",
      "mapType": mapType,
      "isoCode": "DOM",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 62,
      "name": "Algeria",
      "mapType": mapType,
      "isoCode": "DZA",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 63,
      "name": "Ecuador",
      "mapType": mapType,
      "isoCode": "ECU",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 65,
      "name": "Egypt",
      "mapType": mapType,
      "isoCode": "EGY",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 67,
      "name": "Eritrea",
      "mapType": mapType,
      "isoCode": "ERI",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 66,
      "name": "Western Sahara",
      "mapType": mapType,
      "isoCode": "ESH",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 68,
      "name": "Spain",
      "mapType": mapType,
      "isoCode": "ESP",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 64,
      "name": "Estonia",
      "mapType": mapType,
      "isoCode": "EST",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 69,
      "name": "Ethiopia",
      "mapType": mapType,
      "isoCode": "ETH",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 70,
      "name": "Finland",
      "mapType": mapType,
      "isoCode": "FIN",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 71,
      "name": "Fiji",
      "mapType": mapType,
      "isoCode": "FJI",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 72,
      "name": "Falkland Islands (Malvinas)",
      "mapType": mapType,
      "isoCode": "FLK",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 75,
      "name": "France",
      "mapType": mapType,
      "isoCode": "FRA",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 74,
      "name": "Faroe Islands",
      "mapType": mapType,
      "isoCode": "FRO",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 73,
      "name": "Micronesia, Federated States of",
      "mapType": mapType,
      "isoCode": "FSM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 76,
      "name": "Gabon",
      "mapType": mapType,
      "isoCode": "GAB",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 77,
      "name": "United Kingdom",
      "mapType": mapType,
      "isoCode": "GBR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 79,
      "name": "Georgia",
      "mapType": mapType,
      "isoCode": "GEO",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 81,
      "name": "Guernsey",
      "mapType": mapType,
      "isoCode": "GGY",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 82,
      "name": "Ghana",
      "mapType": mapType,
      "isoCode": "GHA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 83,
      "name": "Gibraltar",
      "mapType": mapType,
      "isoCode": "GIB",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 86,
      "name": "Guinea",
      "mapType": mapType,
      "isoCode": "GIN",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 87,
      "name": "Guadeloupe",
      "mapType": mapType,
      "isoCode": "GLP",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 85,
      "name": "Gambia",
      "mapType": mapType,
      "isoCode": "GMB",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 93,
      "name": "Guinea-Bissau",
      "mapType": mapType,
      "isoCode": "GNB",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 88,
      "name": "Equatorial Guinea",
      "mapType": mapType,
      "isoCode": "GNQ",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 89,
      "name": "Greece",
      "mapType": mapType,
      "isoCode": "GRC",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 78,
      "name": "Grenada",
      "mapType": mapType,
      "isoCode": "GRD",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 84,
      "name": "Greenland",
      "mapType": mapType,
      "isoCode": "GRL",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 91,
      "name": "Guatemala",
      "mapType": mapType,
      "isoCode": "GTM",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 80,
      "name": "French Guiana",
      "mapType": mapType,
      "isoCode": "GUF",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 92,
      "name": "Guam",
      "mapType": mapType,
      "isoCode": "GUM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 94,
      "name": "Guyana",
      "mapType": mapType,
      "isoCode": "GUY",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 95,
      "name": "Hong Kong",
      "mapType": mapType,
      "isoCode": "HKG",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 96,
      "name": "Heard Island and McDonald Islands",
      "mapType": mapType,
      "isoCode": "HMD",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 97,
      "name": "Honduras",
      "mapType": mapType,
      "isoCode": "HND",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 98,
      "name": "Croatia",
      "mapType": mapType,
      "isoCode": "HRV",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 99,
      "name": "Haiti",
      "mapType": mapType,
      "isoCode": "HTI",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 100,
      "name": "Hungary",
      "mapType": mapType,
      "isoCode": "HUN",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 101,
      "name": "Indonesia",
      "mapType": mapType,
      "isoCode": "IDN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 104,
      "name": "Isle of Man",
      "mapType": mapType,
      "isoCode": "IMN",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 105,
      "name": "India",
      "mapType": mapType,
      "isoCode": "IND",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 106,
      "name": "British Indian Ocean Territory",
      "mapType": mapType,
      "isoCode": "IOT",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 102,
      "name": "Ireland",
      "mapType": mapType,
      "isoCode": "IRL",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 108,
      "name": "Iran, Islamic Republic of",
      "mapType": mapType,
      "isoCode": "IRN",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 107,
      "name": "Iraq",
      "mapType": mapType,
      "isoCode": "IRQ",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 109,
      "name": "Iceland",
      "mapType": mapType,
      "isoCode": "ISL",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 103,
      "name": "Israel",
      "mapType": mapType,
      "isoCode": "ISR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 110,
      "name": "Italy",
      "mapType": mapType,
      "isoCode": "ITA",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 112,
      "name": "Jamaica",
      "mapType": mapType,
      "isoCode": "JAM",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 111,
      "name": "Jersey",
      "mapType": mapType,
      "isoCode": "JEY",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 113,
      "name": "Jordan",
      "mapType": mapType,
      "isoCode": "JOR",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 114,
      "name": "Japan",
      "mapType": mapType,
      "isoCode": "JPN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 125,
      "name": "Kazakhstan",
      "mapType": mapType,
      "isoCode": "KAZ",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 115,
      "name": "Kenya",
      "mapType": mapType,
      "isoCode": "KEN",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 116,
      "name": "Kyrgyzstan",
      "mapType": mapType,
      "isoCode": "KGZ",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 117,
      "name": "Cambodia",
      "mapType": mapType,
      "isoCode": "KHM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 118,
      "name": "Kiribati",
      "mapType": mapType,
      "isoCode": "KIR",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 120,
      "name": "Saint Kitts and Nevis",
      "mapType": mapType,
      "isoCode": "KNA",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 122,
      "name": "Korea, Republic of",
      "mapType": mapType,
      "isoCode": "KOR",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 123,
      "name": "Kuwait",
      "mapType": mapType,
      "isoCode": "KWT",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 126,
      "name": "Lao People's Democratic Republic",
      "mapType": mapType,
      "isoCode": "LAO",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 127,
      "name": "Lebanon",
      "mapType": mapType,
      "isoCode": "LBN",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 131,
      "name": "Liberia",
      "mapType": mapType,
      "isoCode": "LBR",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 136,
      "name": "Libya",
      "mapType": mapType,
      "isoCode": "LBY",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 128,
      "name": "Saint Lucia",
      "mapType": mapType,
      "isoCode": "LCA",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 129,
      "name": "Liechtenstein",
      "mapType": mapType,
      "isoCode": "LIE",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 130,
      "name": "Sri Lanka",
      "mapType": mapType,
      "isoCode": "LKA",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 132,
      "name": "Lesotho",
      "mapType": mapType,
      "isoCode": "LSO",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 133,
      "name": "Lithuania",
      "mapType": mapType,
      "isoCode": "LTU",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 134,
      "name": "Luxembourg",
      "mapType": mapType,
      "isoCode": "LUX",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 135,
      "name": "Latvia",
      "mapType": mapType,
      "isoCode": "LVA",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 148,
      "name": "Macao",
      "mapType": mapType,
      "isoCode": "MAC",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 141,
      "name": "Saint Martin (French part)",
      "mapType": mapType,
      "isoCode": "MAF",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 137,
      "name": "Morocco",
      "mapType": mapType,
      "isoCode": "MAR",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 138,
      "name": "Monaco",
      "mapType": mapType,
      "isoCode": "MCO",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 139,
      "name": "Moldova, Republic of",
      "mapType": mapType,
      "isoCode": "MDA",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 142,
      "name": "Madagascar",
      "mapType": mapType,
      "isoCode": "MDG",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 155,
      "name": "Maldives",
      "mapType": mapType,
      "isoCode": "MDV",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 157,
      "name": "Mexico",
      "mapType": mapType,
      "isoCode": "MEX",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 143,
      "name": "Marshall Islands",
      "mapType": mapType,
      "isoCode": "MHL",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 144,
      "name": "Macedonia, the Former Yugoslav Republic of",
      "mapType": mapType,
      "isoCode": "MKD",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 145,
      "name": "Mali",
      "mapType": mapType,
      "isoCode": "MLI",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 153,
      "name": "Malta",
      "mapType": mapType,
      "isoCode": "MLT",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 146,
      "name": "Myanmar",
      "mapType": mapType,
      "isoCode": "MMR",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 140,
      "name": "Montenegro",
      "mapType": mapType,
      "isoCode": "MNE",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 147,
      "name": "Mongolia",
      "mapType": mapType,
      "isoCode": "MNG",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 149,
      "name": "Northern Mariana Islands",
      "mapType": mapType,
      "isoCode": "MNP",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 159,
      "name": "Mozambique",
      "mapType": mapType,
      "isoCode": "MOZ",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 151,
      "name": "Mauritania",
      "mapType": mapType,
      "isoCode": "MRT",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 152,
      "name": "Montserrat",
      "mapType": mapType,
      "isoCode": "MSR",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 150,
      "name": "Martinique",
      "mapType": mapType,
      "isoCode": "MTQ",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 154,
      "name": "Mauritius",
      "mapType": mapType,
      "isoCode": "MUS",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 156,
      "name": "Malawi",
      "mapType": mapType,
      "isoCode": "MWI",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 158,
      "name": "Malaysia",
      "mapType": mapType,
      "isoCode": "MYS",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 246,
      "name": "Mayotte",
      "mapType": mapType,
      "isoCode": "MYT",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 160,
      "name": "Namibia",
      "mapType": mapType,
      "isoCode": "NAM",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 161,
      "name": "New Caledonia",
      "mapType": mapType,
      "isoCode": "NCL",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 162,
      "name": "Niger",
      "mapType": mapType,
      "isoCode": "NER",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 163,
      "name": "Norfolk Island",
      "mapType": mapType,
      "isoCode": "NFK",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 164,
      "name": "Nigeria",
      "mapType": mapType,
      "isoCode": "NGA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 165,
      "name": "Nicaragua",
      "mapType": mapType,
      "isoCode": "NIC",
      "active": true,
      "regionId": 8,
      "region": {
        "id": 8,
        "name": "South/Central America"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 170,
      "name": "Niue",
      "mapType": mapType,
      "isoCode": "NIU",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 166,
      "name": "Netherlands",
      "mapType": mapType,
      "isoCode": "NLD",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 167,
      "name": "Norway",
      "mapType": mapType,
      "isoCode": "NOR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 168,
      "name": "Nepal",
      "mapType": mapType,
      "isoCode": "NPL",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 169,
      "name": "Nauru",
      "mapType": mapType,
      "isoCode": "NRU",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 171,
      "name": "New Zealand",
      "mapType": mapType,
      "isoCode": "NZL",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 172,
      "name": "Oman",
      "mapType": mapType,
      "isoCode": "OMN",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 178,
      "name": "Pakistan",
      "mapType": mapType,
      "isoCode": "PAK",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 173,
      "name": "Panama",
      "mapType": mapType,
      "isoCode": "PAN",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 181,
      "name": "Pitcairn",
      "mapType": mapType,
      "isoCode": "PCN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 174,
      "name": "Peru",
      "mapType": mapType,
      "isoCode": "PER",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 177,
      "name": "Philippines",
      "mapType": mapType,
      "isoCode": "PHL",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 185,
      "name": "Palau",
      "mapType": mapType,
      "isoCode": "PLW",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 176,
      "name": "Papua New Guinea",
      "mapType": mapType,
      "isoCode": "PNG",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 179,
      "name": "Poland",
      "mapType": mapType,
      "isoCode": "POL",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 182,
      "name": "Puerto Rico",
      "mapType": mapType,
      "isoCode": "PRI",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 121,
      "name": "Korea, Democratic People's Republic of",
      "mapType": mapType,
      "isoCode": "PRK",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 184,
      "name": "Portugal",
      "mapType": mapType,
      "isoCode": "PRT",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 186,
      "name": "Paraguay",
      "mapType": mapType,
      "isoCode": "PRY",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 183,
      "name": "Palestine, State of",
      "mapType": mapType,
      "isoCode": "PSE",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 175,
      "name": "French Polynesia",
      "mapType": mapType,
      "isoCode": "PYF",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 187,
      "name": "Qatar",
      "mapType": mapType,
      "isoCode": "QAT",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 188,
      "name": "Réunion",
      "mapType": mapType,
      "isoCode": "REU",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 189,
      "name": "Romania",
      "mapType": mapType,
      "isoCode": "ROU",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 191,
      "name": "Russian Federation",
      "mapType": mapType,
      "isoCode": "RUS",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 192,
      "name": "Rwanda",
      "mapType": mapType,
      "isoCode": "RWA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 193,
      "name": "Saudi Arabia",
      "mapType": mapType,
      "isoCode": "SAU",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 196,
      "name": "Sudan",
      "mapType": mapType,
      "isoCode": "SDN",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 205,
      "name": "Senegal",
      "mapType": mapType,
      "isoCode": "SEN",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 198,
      "name": "Singapore",
      "mapType": mapType,
      "isoCode": "SGP",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 90,
      "name": "South Georgia and the South Sandwich Islands",
      "mapType": mapType,
      "isoCode": "SGS",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 199,
      "name": "Saint Helena, Ascension and Tristan da Cunha",
      "mapType": mapType,
      "isoCode": "SHN",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 201,
      "name": "Svalbard and Jan Mayen",
      "mapType": mapType,
      "isoCode": "SJM",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 194,
      "name": "Solomon Islands",
      "mapType": mapType,
      "isoCode": "SLB",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 203,
      "name": "Sierra Leone",
      "mapType": mapType,
      "isoCode": "SLE",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 210,
      "name": "El Salvador",
      "mapType": mapType,
      "isoCode": "SLV",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 204,
      "name": "San Marino",
      "mapType": mapType,
      "isoCode": "SMR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 206,
      "name": "Somalia",
      "mapType": mapType,
      "isoCode": "SOM",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 180,
      "name": "Saint Pierre and Miquelon",
      "mapType": mapType,
      "isoCode": "SPM",
      "active": true,
      "regionId": 7,
      "region": {
        "id": 7,
        "name": regionNorthAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 190,
      "name": "Serbia",
      "mapType": mapType,
      "isoCode": "SRB",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 208,
      "name": "South Sudan",
      "mapType": mapType,
      "isoCode": "SSD",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 209,
      "name": "Sao Tome and Principe",
      "mapType": mapType,
      "isoCode": "STP",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 207,
      "name": "Suriname",
      "mapType": mapType,
      "isoCode": "SUR",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 202,
      "name": "Slovakia",
      "mapType": mapType,
      "isoCode": "SVK",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 200,
      "name": "Slovenia",
      "mapType": mapType,
      "isoCode": "SVN",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 197,
      "name": "Sweden",
      "mapType": mapType,
      "isoCode": "SWE",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 213,
      "name": "Swaziland",
      "mapType": mapType,
      "isoCode": "SWZ",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 211,
      "name": "Sint Maarten (Dutch part)",
      "mapType": mapType,
      "isoCode": "SXM",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 195,
      "name": "Seychelles",
      "mapType": mapType,
      "isoCode": "SYC",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 212,
      "name": "Syrian Arab Republic",
      "mapType": mapType,
      "isoCode": "SYR",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 214,
      "name": "Turks and Caicos Islands",
      "mapType": mapType,
      "isoCode": "TCA",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 215,
      "name": "Chad",
      "mapType": mapType,
      "isoCode": "TCD",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 217,
      "name": "Togo",
      "mapType": mapType,
      "isoCode": "TGO",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 218,
      "name": "Thailand",
      "mapType": mapType,
      "isoCode": "THA",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 219,
      "name": "Tajikistan",
      "mapType": mapType,
      "isoCode": "TJK",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 220,
      "name": "Tokelau",
      "mapType": mapType,
      "isoCode": "TKL",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 222,
      "name": "Turkmenistan",
      "mapType": mapType,
      "isoCode": "TKM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 221,
      "name": "Timor-Leste",
      "mapType": mapType,
      "isoCode": "TLS",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 224,
      "name": "Tonga",
      "mapType": mapType,
      "isoCode": "TON",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 226,
      "name": "Trinidad and Tobago",
      "mapType": mapType,
      "isoCode": "TTO",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 223,
      "name": "Tunisia",
      "mapType": mapType,
      "isoCode": "TUN",
      "active": true,
      "regionId": 6,
      "region": {
        "id": 6,
        "name": regionArabStates
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 225,
      "name": "Turkey",
      "mapType": mapType,
      "isoCode": "TUR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 227,
      "name": "Tuvalu",
      "mapType": mapType,
      "isoCode": "TUV",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 228,
      "name": "Taiwan, Province of China",
      "mapType": mapType,
      "isoCode": "TWN",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 229,
      "name": "Tanzania, United Republic of",
      "mapType": mapType,
      "isoCode": "TZA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 231,
      "name": "Uganda",
      "mapType": mapType,
      "isoCode": "UGA",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 230,
      "name": "Ukraine",
      "mapType": mapType,
      "isoCode": "UKR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 232,
      "name": "United States Minor Outlying Islands",
      "mapType": mapType,
      "isoCode": "UMI",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 234,
      "name": "Uruguay",
      "mapType": mapType,
      "isoCode": "URY",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 233,
      "name": "United States",
      "mapType": mapType,
      "isoCode": "USA",
      "active": true,
      "regionId": 7,
      "region": {
        "id": 7,
        "name": regionNorthAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 235,
      "name": "Uzbekistan",
      "mapType": mapType,
      "isoCode": "UZB",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 236,
      "name": "Holy See (Vatican City State)",
      "mapType": mapType,
      "isoCode": "VAT",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 237,
      "name": "Saint Vincent and the Grenadines",
      "mapType": mapType,
      "isoCode": "VCT",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 238,
      "name": "Venezuela, Bolivarian Republic of",
      "mapType": mapType,
      "isoCode": "VEN",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 239,
      "name": "Virgin Islands, British",
      "mapType": mapType,
      "isoCode": "VGB",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 240,
      "name": "Virgin Islands, U.S.",
      "mapType": mapType,
      "isoCode": "VIR",
      "active": true,
      "regionId": 4,
      "region": {
        "id": 4,
        "name": regionLatinAmerica
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 241,
      "name": "Vietnam",
      "mapType": mapType,
      "isoCode": "VNM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 242,
      "name": "Vanuatu",
      "mapType": mapType,
      "isoCode": "VUT",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 243,
      "name": "Wallis and Futuna",
      "mapType": mapType,
      "isoCode": "WLF",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 244,
      "name": "Samoa",
      "mapType": mapType,
      "isoCode": "WSM",
      "active": true,
      "regionId": 3,
      "region": {
        "id": 3,
        "name": regionAsiaPacific
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 245,
      "name": "Yemen",
      "mapType": mapType,
      "isoCode": "YEM",
      "active": true,
      "regionId": 2,
      "region": {
        "id": 2,
        "name": regionMiddleEast
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 247,
      "name": "South Africa",
      "mapType": mapType,
      "isoCode": "ZAF",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 248,
      "name": "Zambia",
      "mapType": mapType,
      "isoCode": "ZMB",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 249,
      "name": "Zimbabwe",
      "mapType": mapType,
      "isoCode": "ZWE",
      "active": true,
      "regionId": 5,
      "region": {
        "id": 5,
        "name": "Africa"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    },
    {
      "id": 250,
      "name": "Ireland",
      "mapType": mapType,
      "isoCode": "GBR",
      "active": true,
      "regionId": 1,
      "region": {
        "id": 1,
        "name": "Europe"
      },
      "defaultLanguageId": 1,
      "defaultLanguage": {
        "id": 1,
        "name": "English",
        "englishName": "English",
        "isoCode": "ENG"
      }
    }
  ]
